/**
 * Created by razial on 17.01.2021
 */

const UnitsLibrary = function (locationConfig) {
    this.locationConfig = locationConfig;

    const stored = this.locationConfig.slot.load("unitslibrary");
    this.load(stored);
};

UnitsLibrary.prototype.load = function (stored) {
    stored = stored || {};
    stored.opened = stored.opened || {};
    stored.fresh = stored.fresh || {};

    this.opened = this.removeDeletedStages(cleverapps.listFromBit(stored.opened));
    this.fresh = this.removeDeletedStages(cleverapps.listFromBit(stored.fresh));

    this.processUnknown(stored);
};

UnitsLibrary.prototype.save = function (fromServer) {
    this.locationConfig.slot.save("unitslibrary", this.getInfo(), fromServer);
};

UnitsLibrary.prototype.removeDeletedStages = function (data) {
    const result = {};
    Object.keys(data).forEach((code) => {
        const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
        if (!deleted || !deleted.length) {
            result[code] = data[code];
            return;
        }

        result[code] = {};

        for (let stage = 0, convertedStage = 0, lastStage = Math.max(...Object.keys(data[code]).map(Number)); stage <= lastStage;) {
            if (deleted.indexOf(stage) !== -1) {
                stage += 1;
                continue;
            }

            if (data[code][stage]) {
                result[code][convertedStage] = data[code][stage];
            }

            convertedStage += 1;
            stage += 1;
        }
    });
    return result;
};

UnitsLibrary.prototype.restoreDeletedStages = function (data) {
    const result = {};
    Object.keys(data).forEach((code) => {
        const deleted = Families.DELETED_STAGES && Families.DELETED_STAGES[code];
        if (!deleted || !deleted.length) {
            result[code] = data[code];
            return;
        }

        result[code] = {};

        for (let stage = 0, convertedStage = 0, lastStage = Math.max(...Object.keys(data[code]).map(Number)); stage <= lastStage;) {
            if (deleted.indexOf(convertedStage) !== -1) {
                convertedStage += 1;
                continue;
            }

            if (data[code][stage]) {
                result[code][convertedStage] = data[code][stage];
            }

            convertedStage += 1;
            stage += 1;
        }
    });
    return result;
};

UnitsLibrary.prototype.processUnknown = function (stored) {
    this.unknownOpened = {};
    this.unknownFresh = {};

    Object.keys(this.opened).forEach(function (code) {
        if (Families[code] && !this.isHidden({ code })) {
            return;
        }
        if (this.isRedundant({ code }) || !Families[code] && !Unit.DELETED_CODES[code]) {
            this.unknownOpened[code] = stored.opened[code];
            if (stored.fresh[code] !== undefined) {
                this.unknownFresh[code] = stored.fresh[code];
            }
        }
        delete this.opened[code];
        delete this.fresh[code];
    }, this);

    for (const code in this.fresh) {
        Object.keys(this.fresh[code]).forEach(function (stage) {
            if (this.isHiddenFresh({ code, stage })) {
                delete this.fresh[code][stage];
            }
        }, this);
    }

    Families.codes.forEach((code) => {
        if (!this.opened[code]) {
            delete this.opened[code];
            delete this.fresh[code];
        }

        if (!this.fresh[code]) {
            delete this.fresh[code];
        }
    });
};

UnitsLibrary.prototype.getInfo = function () {
    return {
        opened: { ...cleverapps.listToBit(this.restoreDeletedStages(this.opened)), ...this.unknownOpened },
        fresh: { ...cleverapps.listToBit(this.restoreDeletedStages(this.fresh)), ...this.unknownFresh }
    };
};

UnitsLibrary.prototype.reset = function () {
    this.opened = {};
    this.fresh = {};
    this.unknownOpened = {};
    this.unknownFresh = {};
    this.save();
};

UnitsLibrary.prototype.resetFamilies = function (codes) {
    codes = cleverapps.toArray(codes);

    codes.forEach(function (code) {
        delete this.opened[code];
        delete this.fresh[code];
    }, this);

    this.save();
};

UnitsLibrary.prototype.resetUnit = function (unit) {
    if (this.opened[unit.code]) {
        delete this.opened[unit.code][unit.stage];
    }

    if (this.fresh[unit.code]) {
        delete this.fresh[unit.code][unit.stage];
    }

    this.save();
};

UnitsLibrary.LastStage = function (code) {
    const units = Families[code].units;
    for (let id = units.length - 1; id >= 0; id--) {
        if (!units[id].temporary) {
            return {
                code,
                stage: id
            };
        }
    }
};

UnitsLibrary.ListByCode = function (code) {
    const units = Families[code].units;
    const res = [];
    for (let id = 0; id < units.length; id++) {
        if (!units[id].temporary) {
            res.push({
                code,
                stage: id,
                unmergeable: units[id].unmergeable
            });
        }
    }
    return res;
};

UnitsLibrary.prototype.listOpenedPlusOneWithUnknown = function (code) {
    let units = UnitsLibrary.ListByCode(code);

    if (["advsource", "advprize"].indexOf(Families[code].type) !== -1) {
        units = units.filter((unit) => this.isOpened(unit) || Map2d.currentMap.fogs.isPresentOnMap(unit));
    }

    for (let i = units.length - 1; i >= 1; i--) {
        if (this.isOpened(units[i]) || this.isOpened(units[i - 1])) {
            break;
        }

        units[i].unknown = true;
    }

    if (units.length > 0) {
        units[units.length - 1].last = true;
    }

    return units;
};

UnitsLibrary.prototype.isOpened = function (unit) {
    if (this.isRedundant(unit)) {
        cleverapps.throwAsync(`UnitsLibrary.isOpened for redundant unit ${unit.code} ${unit.stage}`);
        return false;
    }

    return this.opened[unit.code] && this.opened[unit.code][unit.stage];
};

UnitsLibrary.prototype.isFresh = function (unit) {
    if (this.isRedundant(unit)) {
        cleverapps.throwAsync(`UnitsLibrary.isFresh for redundant unit ${unit.code} ${unit.stage}`);
        return false;
    }

    return this.fresh[unit.code] && this.fresh[unit.code][unit.stage] !== undefined;
};

UnitsLibrary.prototype.openUnit = function (unit) {
    if (!this.isHidden(unit) && !this.isOpened(unit)) {
        if (!this.opened[unit.code]) {
            this.opened[unit.code] = {};
        }

        this.opened[unit.code][unit.stage] = true;

        if (!this.isHiddenFresh(unit)) {
            if (!this.fresh[unit.code]) {
                this.fresh[unit.code] = {};
            }

            this.fresh[unit.code][unit.stage] = true;
        }

        cleverapps.eventBus.trigger("unitOpened", unit);
        cleverapps.eventBus.trigger("unitStatusChanged", unit);

        cleverapps.toolbar.resetByType(ToolbarItem.UNITS_LIBRARY);
        cleverapps.offerManager.refreshByHero(unit);

        this.save();

        return true;
    }
};

UnitsLibrary.prototype.isHidden = function (unit) {
    return UnitsLibrary.HIDDEN_CODES.indexOf(unit.code) !== -1 || this.isRedundant(unit)
        || UnitsLibrary.HIDDEN_TYPES.indexOf(Families[unit.code].type) !== -1;
};

UnitsLibrary.prototype.isRedundant = function (unit) {
    return UnitsLibrary.REDUNDANT_CODES.indexOf(unit.code) !== -1;
};

UnitsLibrary.prototype.isHiddenFresh = function (unit) {
    const family = Families[unit.code];
    const data = family.units[unit.stage];

    if (data === undefined) {
        console.log("UNIT", unit.code, unit.stage);
        return false;
    }

    return this.isHidden(unit)
        || UnitsLibrary.HIDDEN_FRESH_CODES.indexOf(unit.code) !== -1 || data.temporary
        || UnitsLibrary.HIDDEN_FRESH_TYPES.indexOf(family.type) !== -1;
};

UnitsLibrary.prototype.removeFresh = function (unit, source) {
    if (this.fresh[unit.code][unit.stage]) {
        delete this.fresh[unit.code][unit.stage];

        this.addReward(unit, source);

        cleverapps.eventBus.trigger("unitStatusChanged", unit);

        cleverapps.toolbar.resetByType(ToolbarItem.UNITS_LIBRARY);

        this.save();
    }
};

UnitsLibrary.prototype.addReward = function (unit, source) {
    Map2dLocation.currentLocation.addReward("soft", this.calcRewardCoins(unit), source, {
        event: cleverapps.EVENTS.EARN.LIBRARY
    });
};

UnitsLibrary.prototype.hasOpened = function (code) {
    return Object.keys(this.opened[code] || {}).length > 0;
};

UnitsLibrary.prototype.hasFresh = function (code) {
    return Object.keys(this.fresh[code] || {}).length > 0;
};

UnitsLibrary.prototype.listAvailableByType = function (type) {
    const codes = this.listCodesByType(type).filter(function (code) {
        return this.hasOpened(code);
    }, this);

    if (codes.length === 0) {
        const current = this.getCurrentOfType(type);
        if (current) {
            return [current];
        }
    }

    return codes;
};

UnitsLibrary.prototype.listOpenedOfType = function (type) {
    return this.listCodesByType(type).filter(function (code) {
        return this.hasOpened(code);
    }, this);
};

UnitsLibrary.prototype.getCurrentOfType = function (type, locationId) {
    switch (type) {
        case "resource": case "drresource": case "searesource": case "rpresource": case "earesource":
            return this.getCurrentResource(type, locationId);
        case "hero": case "drhero": case "seahero": case "rphero": case "eahero":
            return this.getCurrentHero(type);
        case "fruit":
            return this.getCurrentFruit(locationId);
        case "source":
            return `${this.getCurrentResource("resource", locationId)}source`;
        case "chest":
            return `${this.getCurrentResource("resource", locationId)}chest`;
    }
};

UnitsLibrary.prototype.listCodesByType = function (types, locationId) {
    if (Array.isArray(types)) {
        return types.reduce((res, type) => res.concat(this.listCodesByType(type)), []);
    }
    let codesByType = (UnitsLibrary.codesByType[types] || []).slice();

    const families = locationId ? Families.listExpeditionCodes(locationId) : cleverapps.meta.getSelectedLocation().families;
    if (families) {
        codesByType = codesByType.filter((code) => families[code]);
    }

    return codesByType;
};

UnitsLibrary.prototype.listOpened = function (code) {
    return UnitsLibrary.ListByCode(code).filter(this.isOpened.bind(this));
};

UnitsLibrary.prototype.getFamilyName = function (code) {
    return Messages.get(`Units.${code}.name`);
};

UnitsLibrary.prototype.getUnitName = function (unit) {
    const key = `Units.${unit.code}.stage${unit.stage + 1}.name`;
    const fallbackName = `${unit.code} stage ${unit.stage + 1}`;

    if (Families[unit.code] && Families[unit.code].localization === false) {
        return fallbackName;
    }

    return Messages.get(key);
};

UnitsLibrary.prototype.hasAnyFresh = function (codes) {
    return codes.some(this.hasFresh.bind(this));
};

UnitsLibrary.prototype.calcRewardCoins = function (unit) {
    return Math.round(3 * Math.pow(1.3, unit.stage));
};

UnitsLibrary.prototype.getLastOpenStage = function (code) {
    const units = Families[code].units;

    for (let stage = units.length - 1; stage >= 0; stage--) {
        if (this.isOpened({ code, stage })) {
            return stage;
        }
    }

    return undefined;
};

UnitsLibrary.prototype.getLastOpenCode = function (type, locationId) {
    const codesByType = this.listCodesByType(type, locationId);
    for (let i = codesByType.length - 1; i >= 0; i--) {
        const code = codesByType[i];

        if (this.hasOpened(code)) {
            return code;
        }
    }

    return codesByType[0];
};

UnitsLibrary.prototype.getCurrentResource = function (type, locationId) {
    return this.getLastOpenCode(type || "resource", locationId);
};

UnitsLibrary.prototype.getCurrentCastleResource = function (type) {
    type = type || "resource";
    const codesByType = this.listCodesByType(type);
    for (let i = codesByType.length - 1; i >= 0; i--) {
        const code = codesByType[i];

        if (this.hasOpened(code) && !this.isOpened({ code, stage: Families[code].units.length - 1 })) {
            return code;
        }
    }

    return this.getCurrentResource(type);
};

UnitsLibrary.prototype.getCurrentFruit = function (locationId) {
    return this.getLastOpenCode("fruit", locationId);
};

UnitsLibrary.prototype.listUnopenedHeroes = function (type) {
    type = type || "hero";

    const location = cleverapps.meta.getSelectedLocation();
    const codesByType = this.listCodesByType(type);
    const heroes = [];

    for (let i = 0; i < codesByType.length; i++) {
        const code = codesByType[i];

        if (!this.isHeroAvailable(code)) {
            if (Unit.GetDropType(code) === FamiliesHelper.Drop.Open) {
                if (this.getLastOpenStage(code) !== undefined) {
                    heroes.push(code);
                }
            } else if (!heroes.length || location.locationConfig.parallelHeroDrop) {
                heroes.push(code);
            }
        }
    }

    return heroes;
};

UnitsLibrary.prototype.getCurrentHero = function (type) {
    const heroes = this.listUnopenedHeroes(type);

    return heroes[0];
};

UnitsLibrary.prototype.getActiveHero = function (type) {
    type = type || "hero";
    const codesByType = this.listCodesByType(type);

    for (let i = codesByType.length - 1; i >= 0; i--) {
        const code = codesByType[i];
        if (this.isHeroAvailable(code)) {
            return code;
        }
    }

    return undefined;
};

UnitsLibrary.prototype.isHeroAvailable = function (code) {
    return this.listAvailableHeroes().some((unit) => unit.code === code);
};

UnitsLibrary.prototype.listAvailableHeroes = function () {
    return Map2d.currentMap.listAvailableHeroes();
};

UnitsLibrary.prototype.findFreshUnit = function (units) {
    for (let i = 0; i < units.length; ++i) {
        const unit = units[i];
        if (unit.code && (unit.stage === undefined && this.hasFresh(unit.code) || this.isFresh(unit))) {
            return unit;
        }
    }
};

UnitsLibrary.prototype.findLastOpenedUnit = function (units) {
    for (let i = units.length - 1; i >= 0; --i) {
        const unit = units[i];
        if (unit.code && this.isOpened(unit)) {
            return unit;
        }
    }
};

UnitsLibrary.prototype.listTabCodes = function (locationId, tabId) {
    const codesById = cleverapps.clone(UnitsLibrary.codesByTabId[locationId] || UnitsLibrary.codesByTabId.main, true);

    if (locationId === "main" && Families.telly && connector.ads.isRewardedSupported || this.listCodesByType("telly", locationId).some(this.hasOpened, this)) {
        codesById[5].push("telly");
    }

    if (locationId === "dragonia2") {
        codesById[1] = codesById[1].filter((code) => !["dr2wheat", "dr2coal", "dr2barrel"].includes(code));
    }

    const codes = codesById[tabId] || codesById.reduce((totalCodes, tabCodes) => totalCodes.concat(tabCodes), []);

    return codes;
};

UnitsLibrary.prototype.getExpeditionUnitType = function (type) {
    const expeditionType = UnitsLibrary.EXPEDITION_PREFIXES[cleverapps.meta.selectedLocationId()] + type;
    return Families.types[expeditionType] ? expeditionType : type;
};

UnitsLibrary.Init = function () {
    this.codesByType = {};

    Families.codes.forEach(function (code) {
        const type = Families[code].type;

        if (!this.codesByType[type]) {
            this.codesByType[type] = [];
        }

        this.codesByType[type].push(code);
    }, this);

    this.codesByTabId = cleverapps.clone(UnitsLibrary.CODES_BY_TAB, true);

    this.codesByTabId.main = [
        ["hero"],
        ["resource"],
        ["fruit"],
        ["source", "generator"],
        ["chest", "coinscup", "energycup", "caravanbox"],
        ["valuables", "custom", "magicplant", "energytree", "coinstree"]
    ];

    const allLocations = [...new Set(Families.codes.map(
        (code) => Families[code].expeditions || []
    ).reduce((a, b) => a.concat(b), []).filter(cleverapps.isNumber).map(Number))];

    allLocations.forEach((location) => {
        this.codesByTabId[location] = this.codesByTabId.main;
    });
    
    Object.keys(this.codesByTabId).forEach(function (locationId) {
        const families = Families.listExpeditionCodes(cleverapps.isNumber(locationId) ? parseInt(locationId) : locationId);
        //
        this.codesByTabId[locationId] = this.codesByTabId[locationId].map(function (types) {
            types = cleverapps.substract(types, UnitsLibrary.HIDDEN_TYPES);
            types = cleverapps.substract(types, UnitsLibrary.HIDDEN_FRESH_TYPES);

            let codes = types.reduce((total, type) => {
                if (families[type]) {
                    return total.concat(type);
                }

                if (this.codesByType[type]) {
                    return total.concat(this.codesByType[type].filter((code) => families[code]));
                }

                return total;
            }, []);
            codes = cleverapps.substract(codes, UnitsLibrary.HIDDEN_CODES);
            codes = cleverapps.substract(codes, UnitsLibrary.HIDDEN_FRESH_CODES);
            codes = cleverapps.substract(codes, UnitsLibrary.REDUNDANT_CODES);
            return codes;
        }, this);
    }, this);
};

UnitsLibrary.EXPEDITION_PREFIXES = {
    collections: "cl"
};

UnitsLibrary.HIDDEN_CODES = ["multiCellBody", "thirdelement", "t", "debugunit"];
UnitsLibrary.HIDDEN_TYPES = ["battlepasspoints"];
UnitsLibrary.REDUNDANT_CODES = ["landmark"];

UnitsLibrary.HIDDEN_FRESH_CODES = ["dragonmine", "rubiesplantchest", "coinsplantchest", "energyplantchest", "cllandmark", "landmarkspot", "landmarkpreview"];
if (cleverapps.config.ui === "wooden") {
    UnitsLibrary.HIDDEN_FRESH_CODES.push("dailytaskchest");
}
UnitsLibrary.HIDDEN_FRESH_TYPES = ["merge3generator", "unitsshop", "monster", "ruins"];

UnitsLibrary.OLD_EXPEDITION_INTERVAL = cleverapps.parseInterval("2 weeks");
UnitsLibrary.CODES_BY_TAB = {};

UnitsLibrary.UNIT_LOCATOR_TYPE_BY_EXPEDITION = {};

if (typeof cc === "undefined") {
    module.exports = UnitsLibrary;
}
